import { Button } from '@material-tailwind/react';

const ButtonGlobal = ({ text, type, click, error = false, loading = false, disabled = false }) => {
  return (
    <>
      <Button
        variant="gradient"
        color={`${error ? 'red' : 'blue'}`}
        className={`dark:text-gray-100 dark:!bg-darkGlButon ${!!error && 'dark:!bg-red-600 '} `}
        disabled={!!error || loading || disabled}
        size="lg"
        type={type}
        onClick={() => click()}
        loading={loading}
      >
        {error ? 'Verifique form...' : text}
      </Button>
    </>
  );
};

export default ButtonGlobal;
